import { generateUploadButton, generateUploadDropzone } from '@uploadthing/react'

import type { OurFileRouter } from '@/app/api/uploadthing/core'

export const UploadButton = generateUploadButton<OurFileRouter>()
export const UploadDropzone = generateUploadDropzone<OurFileRouter>()

import { genUploader } from 'uploadthing/client'

export const { uploadFiles } = genUploader<OurFileRouter>()
